export enum SignatureFormType {
  Disclaimer = 'Disclaimer',
  Default = 'Default',
}
